"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _ChevronDown = _interopRequireDefault(require("../../../../icons-react/rebrand/ChevronDown"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DropdownButton = exports.DropdownButton = function DropdownButton(_ref) {
  var label = _ref.label,
    isOpen = _ref.isOpen,
    isFiltersMobile = _ref.isFiltersMobile;
  return /*#__PURE__*/_react["default"].createElement(StyledDropdownButton, null, /*#__PURE__*/_react["default"].createElement("span", null, label), !isFiltersMobile && /*#__PURE__*/_react["default"].createElement(StyledChevronDownIcon, {
    $isOpen: isOpen
  }));
};
var StyledDropdownButton = _styledComponents["default"].span.withConfig({
  displayName: "DropdownButton__StyledDropdownButton",
  componentId: "sc-f7iyd3-0"
})(["display:flex;align-items:center;gap:4px;padding:12px;--background-color:var(--white);background:var(--background-color);border-radius:var(--border-radius);color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;"]);
var StyledChevronDownIcon = (0, _styledComponents["default"])(_ChevronDown["default"]).withConfig({
  displayName: "DropdownButton__StyledChevronDownIcon",
  componentId: "sc-f7iyd3-1"
})(["height:12px;", ""], function (_ref2) {
  var $isOpen = _ref2.$isOpen;
  return $isOpen && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});